module.exports = __webpack_public_path__ + "static/img/qiangzhuangtuitongzi.8b5ce38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/qiangzhuangtuitongzi.jpg
// module id = 6OjC
// module chunks = 0